module.exports = __webpack_public_path__ + "img/divvy.608a384d.jpg";